<template>
	<svg viewBox="0 0 15 32">
		<path d="M6.688 11.25c0 0.875-0.813 1.813-1.875 1.813v15.063c0 2.125-2.875 2.125-2.875 0v-15.063c-1 0-1.938-0.813-1.938-2v-8.25c0-0.75 1.063-0.75 1.063 0v6.125h0.875v-6.188c0-0.688 1-0.688 1 0.063v6.125h0.875v-6.188c0-0.688 1-0.688 1 0.063v6.125h0.875v-6.188c0-0.688 1-0.688 1 0.063v8.438zM14.5 4.75v23.375c0 2.063-2.938 2.063-2.938 0v-9.25h-1.563v-14.125c0-3.313 4.5-3.313 4.5 0z" />
	</svg>
</template>
